export default function InfoAppsPremium() {
    return (
        <>
            <div class="container text-start">
                <div class="row">
                    {/*lionsgate+ */}
                   
                    {/* Hube */}
                    <div class="col">
                        <img src='https://hdflgabrcqndyvcnyjtn.supabase.co/storage/v1/object/public/imagens/apps/hube' class="mt-3" alt="..." height="80" width="80" />
                        <div class="card-body">
                            <h5 class="card-title my-2 fw-normal">Hube</h5>
                            <p class="card-text mb-0 text-muted">
                                Agora você pode levar seus jornais e revistas favoritos para onde quiser! O hube é um aplicativo de conteúdos que te deixa sempre atualizado e muito bem-informado.
                            </p>
                            <a href="https://playhub.movidesk.com/kb/article/275094/hube" class="link-orange">Como ativar</a>
                        </div>
                    </div>

                </div>
                <div class="row">
                    {/* Fluid */}
                    <div class="col">
                        <img src='https://hdflgabrcqndyvcnyjtn.supabase.co/storage/v1/object/public/imagens/apps/fluid' class="mt-3" alt="..." height="80" width="80" />
                        <div class="card-body">
                            <h5 class="card-title my-2 fw-normal">Fluid</h5>
                            <p class="card-text mb-0 text-muted">
                                Agora você pode realizar todas as práticas guiadas de yoga e meditação e fazer delas um hábito diário. Transforme sua qualidade de vida e comece agora sua jornada interior.                                    </p>
                            <a href="https://playhub.movidesk.com/kb/article/275091/fluid" class="link-orange">Como ativar</a>
                        </div>
                    </div>
                    {/* Deezer */}
                    <div class="col">
                        <img src='https://hdflgabrcqndyvcnyjtn.supabase.co/storage/v1/object/public/imagens/apps/deezer' class="mt-3" alt="..." height="80" width="80" />
                        <div class="card-body">
                            <h5 class="card-title my-2 fw-normal">Deezer</h5>
                            <p class="card-text mb-0 text-muted">
                                A Deezer é um aplicativo de músicas e podcasts com mais de 90 milhões de faixas. Aqui você encontra os últimos lançamentos, sucessos e álbuns recém saídos do forno.                                    </p>
                            <a href="https://playhub.movidesk.com/kb/article/275064/deezer" class="link-orange">Como ativar</a>
                        </div>
                    </div>
                </div>
                <div class="row">
                    {/* Super Comics */}
                    <div class="col">
                        <img src='https://hdflgabrcqndyvcnyjtn.supabase.co/storage/v1/object/public/imagens/apps/supercomics' class="mt-3" alt="..." height="80" width="80" />
                        <div class="card-body">
                            <h5 class="card-title my-2 fw-normal">Super Comics</h5>
                            <p class="card-text mb-0 text-muted">
                                Clube de Quadrinhos é um serviço de conteúdo de entretenimento com histórias em quadrinhos.
                            </p>
                            <a href="#" class="link-orange">Como ativar</a>
                        </div>
                    </div>
                    {/* Maia */}
                    <div class="col">
                        <img src='https://hdflgabrcqndyvcnyjtn.supabase.co/storage/v1/object/public/imagens/apps/maia' class="mt-3" alt="..." height="80" width="80" />
                        <div class="card-body">
                            <h5 class="card-title my-2 fw-normal">Maia</h5>
                            <p class="card-text mb-0 text-muted">
                                Minha Assistente com Inteligência Artificial” é um serviço que permite aos seus usuários acessarem funcionalidades que auxiliam na produtividade e organização do dia a dia, como criar e gerenciar listas, arquivos na nuvem, acesso rápido às últimas notícias, previsão do tempo e muito mais.
                            </p>
                            <a href="https://playhub.movidesk.com/kb/article/275097/maia" class="link-orange">Como ativar</a>
                        </div>
                    </div>
                </div>
                <div class="row">
                    {/* Ubook */}
                    <div class="col">
                        <img src='https://hdflgabrcqndyvcnyjtn.supabase.co/storage/v1/object/public/imagens/apps/ubook' class="mt-3" alt="..." height="80" width="80" />
                        <div class="card-body">
                            <h5 class="card-title my-2 fw-normal">Ubook</h5>
                            <p class="card-text mb-0 text-muted">
                                Somos um serviço de assinatura de audiolivros e livros digitais por streaming: você assina e tem acesso ao nosso acervo de modo ilimitado para ouvir e ler milhares de títulos - livros, revistas, podcasts, etc - de várias categorias e idiomas em nossa plataforma.
                            </p>
                            <a href="https://playhub.movidesk.com/kb/article/275120/ubook" class="link-orange">Como ativar</a>
                        </div>
                    </div>
                    {/* Looke */}
                    <div class="col">
                        <img src='https://hdflgabrcqndyvcnyjtn.supabase.co/storage/v1/object/public/imagens/apps/looke' class="mt-3" alt="..." height="80" width="80" />
                        <div class="card-body">
                            <h5 class="card-title my-2 fw-normal">Looke</h5>
                            <p class="card-text mb-0 text-muted">
                                Looke é um aplicativo de streaming de vídeo que trabalha com TVOD e SVOD e permite aos usuários assistir a filmes, séries quando e onde quiser. Você pode ter acesso ao conteúdo por uma plano mensal ou por compras avulsas.
                            </p>
                            <a href="https://playhub.movidesk.com/kb/article/275096/looke" class="link-orange">Como ativar</a>
                        </div>
                    </div>
                </div>
                <div class="row">
                    {/*Pocoyo */}
                    <div class="col">
                        <img src='https://hdflgabrcqndyvcnyjtn.supabase.co/storage/v1/object/public/imagens/apps/pocoyo' class="mt-3" alt="..." height="80" width="80" />
                        <div class="card-body">
                            <h5 class="card-title my-2 fw-normal">Pocoyo</h5>
                            <p class="card-text mb-0 text-muted">
                                Toda a diversão e entretenimento com Pocoyo.
                            </p>
                            <a href="https://playhub.movidesk.com/kb/article/275114/pocoyo" class="link-orange">Como ativar</a>
                        </div>
                    </div>
                    {/* Clube de Ciências */}
                    <div class="col">
                        <img src='https://hdflgabrcqndyvcnyjtn.supabase.co/storage/v1/object/public/imagens/apps/clubedeciencias' class="mt-3" alt="..." height="80" width="80" />
                        <div class="card-body">
                            <h5 class="card-title my-2 fw-normal">Clube de Ciências</h5>
                            <p class="card-text mb-0 text-muted">No Clube Ciências, você aprende e desenvolve suas habilidades em diferentes áreas do conhecimento de forma interativa e divertida!
                            </p>
                            <a href="https://playhub.movidesk.com/kb/article/275100/clube-de-ciencias" class="link-orange">Como ativar</a>
                        </div>
                    </div>
                </div>
                <div class="row">
                    {/* Fuze Forge */}
                    <div class="col">
                        <img src='https://hdflgabrcqndyvcnyjtn.supabase.co/storage/v1/object/public/imagens/apps/fuzeforge' class="mt-3" alt="..." height="80" width="80" />
                        <div class="card-body">
                            <h5 class="card-title my-2 fw-normal">Fuze Forge</h5>
                            <p class="card-text mb-0 text-muted">
                                Divirta-se com conteúdo exclusivos sobre as principais ligas!
                            </p>
                            <a href="https://playhub.movidesk.com/kb/article/275076/fuze-forge" class="link-orange">Como ativar</a>
                        </div>
                    </div>
                    {/* Galinha Pintadinha */}
                    <div class="col">
                        <img src='https://hdflgabrcqndyvcnyjtn.supabase.co/storage/v1/object/public/imagens/apps/galinhapintadinha' class="mt-3" alt="..." height="80" width="80" />
                        <div class="card-body">
                            <h5 class="card-title my-2 fw-normal">Galinha Pintadinha</h5>
                            <p class="card-text mb-0 text-muted">
                                Crescendo com a Galinha Pintadinha.
                            </p>
                            <a href="https://playhub.movidesk.com/kb/article/275092/galinha-pintadinha" class="link-orange">Como ativar</a>
                        </div>
                    </div>
                </div>
                <div class="row">
                    {/* PlayKids */}
                    <div class="col">
                        <img src='https://hdflgabrcqndyvcnyjtn.supabase.co/storage/v1/object/public/imagens/apps/playkids' class="mt-3" alt="..." height="80" width="80" />
                        <div class="card-body">
                            <h5 class="card-title my-2 fw-normal">PlayKids</h5>
                            <p class="card-text mb-0 text-muted">
                                PlayKids é uma plataforma premiada que promove o desenvolvimento infantil pelo mundo, para crianças de 0 a 6 anos de idade. Mais de 5.000 desenhos, livros, jogos educativos e atividades interativas.                                    </p>
                            <a href="https://playhub.movidesk.com/kb/article/275098/playkids" class="link-orange">Como ativar</a>
                        </div>
                    </div>
                    {/* Tap Lingo */}
                    <div class="col">
                        <img src='https://hdflgabrcqndyvcnyjtn.supabase.co/storage/v1/object/public/imagens/apps/taplingo' class="mt-3" alt="..." height="80" width="80" />
                        <div class="card-body">
                            <h5 class="card-title my-2 fw-normal">Tap Lingo</h5>
                            <p class="card-text mb-0 text-muted">
                                Uma maneira rápida e divertida para aprender novos idiomas!
                            </p>
                            <a href="https://playhub.movidesk.com/kb/article/293145/taplingo?ticketId=&q=tap" class="link-orange">Como ativar</a>
                        </div>
                    </div>
                </div>
                <div class="row">
                    {/* TO AQUI */}
                    <div class="col">
                        <img src='https://hdflgabrcqndyvcnyjtn.supabase.co/storage/v1/object/public/imagens/apps/toaqui' class="mt-3" alt="..." height="80" width="80" />
                        <div class="card-body">
                            <h5 class="card-title my-2 fw-normal">Tô aqui</h5>
                            <p class="card-text mb-0 text-muted">
                                Um localizador e com apenas um clique, é possível acessar o mapa e ver onde estão as pessoas que mais importam para você.
                            </p>
                            <a href="https://playhub.movidesk.com/kb/article/297408/to-aqui?ticketId=&q=to%20aqui" class="link-orange">Como ativar</a>
                        </div>
                    </div>
                    {/* Reforça */}
                    <div class="col">
                        <img src='https://hdflgabrcqndyvcnyjtn.supabase.co/storage/v1/object/public/imagens/apps/reforca' class="mt-3" alt="..." height="80" width="80" />
                        <div class="card-body">
                            <h5 class="card-title my-2 fw-normal">Reforça</h5>
                            <p class="card-text mb-0 text-muted">
                                Um app com cards que tiram as dúvidas das principais matérias de forma simples e divertida.
                            </p>
                            <a href="https://playhub.movidesk.com/kb/article/293041/reforca?ticketId=&q=refor%C3%A7a" class="link-orange">Como ativar</a>
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
}
